import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { GlobalHttpClient } from '../global.http.client';
import { Helpers } from '../helpers';
import { IPage } from '../models/common/paging';
import { AddSubscriberNoticeNoteDto, BookmarkedTenderSearchRequest, SentToBidManagementSearchRequest, TenderSearchRequest, TenderSummaryDto } from '../models/tenders/tender.models';
import { TenderTabCountDto } from '../models/tenders/tender.tab.count.model';
import { TenderTabInformationDto } from '../models/tenders/tender.tab.information.model';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';

@Injectable()
export class TenderService extends BaseService implements ISearchService<TenderSearchRequest,
TenderSummaryDto> {

    constructor(private readonly helpers: Helpers, http: GlobalHttpClient, private readonly configuration: Configuration) {
        super(http);
    }

    search(request: TenderSearchRequest): Observable<IPage<TenderSummaryDto>> {
        return this.http.post<IPage<TenderSummaryDto>>('tenders/search', request);
    }

    downloadCsv(request: TenderSearchRequest) {
        var url = `${this.configuration.routing.api.baseUrl}/tenders/getSearchCsv?${this.helpers.uriEncode(request)}`;
        window.location.href = url;
    }

    sendToBidManagement(tenderId: number) {
        return this.http.get(`noticeActions/sendToBidManagement/${tenderId}`);
    }

    removeFromBidManagement(tenderId: number) {
        return this.http.delete(`noticeActions/removeFromBidManagement/${tenderId}`);
    }

    getDetails(tenderId: number) {
        return this.http.get(`tenders/getDetails/${tenderId}`);
    }

    hasDocuments(tenderId: number) {
        return this.http.get(`tenders/hasDocuments/${tenderId}`);
    }

    getHvtSection(tenderId: number, sectionNumber: number) {
        return this.http.get(`notices/hvtSection/${tenderId}/${sectionNumber}`);
    }

    getSchema8Section(tenderId: number, sectionNumber: number) {
        return this.http.get(`notices/schema8Section/${tenderId}/${sectionNumber}`);
    }

    //addNote(tenderId: number, content: string) {
    //    return this.http.post('noticeActions/addNote', { noticeId: tenderId, content: content });
    //}

    addNote(request: AddSubscriberNoticeNoteDto) {
        return this.http.post('noticeActions/addNote', request);
    }

    viewDocument(documentId: number) {
        return this.http.post('noticeActions/viewDocument', { documentId: documentId });
    }

    viewZipDocument(noticeId: number) {
        return this.http.post('noticeActions/viewZipDocument', { noticeId: noticeId });
    }

    acknowledgeDocuments() {

    }

    getSentToBidManagement(request: SentToBidManagementSearchRequest) {
        return this.http.getWithParams('tenders/getSentToBidManagement', request);
    }

    getForPrint(tenderId: number) {
        return this.http.get(`notices/getForPrint/${tenderId}`);
    }

    addReminder(tenderId: number, due: string, text: string) {
        return this.http.post('noticeActions/reminder', { noticeId: tenderId, due: due, text: text });
    }

    bookmark(tenderId: number) {
        return this.http.get(`noticeActions/bookmark/${tenderId}`);
    }

    assign(tenderId: number, customerId: number) {
        return this.http.post('noticeActions/assign', { noticeId: tenderId, customerId: customerId });
    }

    getBookmarked(request: BookmarkedTenderSearchRequest) {
        return this.http.getWithParams('tenders/getBookmarked', request);
    }

    getSharedBookmarked(request: BookmarkedTenderSearchRequest) {
        return this.http.getWithParams('tenders/getSharedBookmarked', request);
    }

    getBookmarks(request: BookmarkedTenderSearchRequest) {
        return this.http.getWithParams('tenders/getBookmarks', request);
    }

    getAssigned(request: BookmarkedTenderSearchRequest) {
        return this.http.getWithParams('tenders/getAssigned', request);
    }

    removeBookmark(bookmarkId: number) {
        return this.http.delete(`noticeActions/bookmark/${bookmarkId}`);
    }

    getTabCount(tabInfo: TenderTabInformationDto): Observable<TenderTabCountDto> {
        return this.http.post<TenderTabCountDto>(`tenders/getTabCount`, tabInfo);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/tender.service.ts